// Vuetify's own strings (data-table paging, "No data available", date picker,
// file input, …) form a second catalog next to our vue-i18n messages. We use
// Vuetify's built-in locale system with its shipped packs — deliberately NOT
// the vue-i18n adapter, so these strings never have to be merged into our 28
// message files.
//
// Coverage: every supported locale except ga/mt (fall back to en) and fr-CA
// (shares fr). The active pack is switched by setLanguage() via
// vuetifyLocaleName() in src/i18n/index.js.

import {
  en,
  bg,
  cs,
  da,
  de,
  el,
  es,
  et,
  fi,
  fr,
  hr,
  hu,
  it,
  lt,
  lv,
  nl,
  no,
  pl,
  pt,
  ro,
  ru,
  sk,
  sl,
  sv,
  uk,
} from "vuetify/locale";

export const vuetifyMessages = {
  en,
  bg,
  cs,
  da,
  de,
  el,
  es,
  et,
  fi,
  fr,
  hr,
  hu,
  it,
  lt,
  lv,
  nl,
  no,
  pl,
  pt,
  ro,
  ru,
  sk,
  sl,
  sv,
  uk,
};
